import { invertObj } from "ramda";

const CUB_SCOUTING = "cubScouting";
const SCOUTS_BSA = "scoutsBSA";
const VARSITY_SCOUTING = "varsityScouting";
const VENTURING = "venturing";
const SEA_SCOUTING = "seaScouting";
const EXPLORING_POST = "exploringPost";
const EXPLORING_CLUB = "exploringClub";
const EXPLORING_LAB = "exploringLab";
const LONE_SCOUT = "loneScout";
const LONE_CUB = "loneCub";

export const UNKNOWN_PROGRAM = "UNKNOWN_PROGRAM";
export const ALL_PROGRAMS = "ALL_PROGRAMS";

export const PROGRAM_CODES = {
  CUB_SCOUTING,
  SCOUTS_BSA,
  VARSITY_SCOUTING,
  VENTURING,
  SEA_SCOUTING,
  EXPLORING_POST,
  EXPLORING_CLUB,
  EXPLORING_LAB,
  LONE_SCOUT,
  LONE_CUB,
};

export const PROGRAM_TYPE_CODES_BY_ID = {
  26: LONE_CUB,
  27: LONE_SCOUT,
};

export const PROGRAM_CODES_BY_ID = {
  1: CUB_SCOUTING,
  2: SCOUTS_BSA,
  3: VARSITY_SCOUTING,
  4: VENTURING,
  5: SEA_SCOUTING,
  6: EXPLORING_POST,
  7: EXPLORING_CLUB,
  8: EXPLORING_LAB,
  11: LONE_SCOUT,
  12: LONE_CUB,
};

export const PROGRAM_ID_BY_CODES = invertObj(PROGRAM_CODES_BY_ID);

export const PROGRAM_NAMES = {
  [SCOUTS_BSA]: "Scouts BSA",
  [CUB_SCOUTING]: "Cub Scouting",
  [SEA_SCOUTING]: "Sea Scouting",
  [VARSITY_SCOUTING]: "Varsity",
  [VENTURING]: "Venturing",
  [EXPLORING_POST]: "Exploring",
  [EXPLORING_CLUB]: "Exploring",
  [EXPLORING_LAB]: "Exploring",
  [LONE_SCOUT]: "Lone Scout",
  [LONE_CUB]: "Lone Cub",
};

export const OLD_PROGRAM_NAMES_ID_MAP = {
  "Cub Scouting": 1,
  "Scouts BSA": 2,
  "Varsity Scouting": 3,
  Venturing: 4,
  "Sea Scouting": 5,
  Exploring: 6,
};

export const AWARDS = "awards";
export const RANKS = "ranks";
export const ADVENTURES = "adventures";
export const MERIT_BADGES = "meritBadges";
export const ELECTIVES = "electives";
export const PALMS = "palms";
export const PATH_TO_EAGLE = "pathToEagle";
export const LEADERSHIP = "leadership";
export const ACTIVITY_LOGS = "activityLogs";
export const CAREER_ACHIEVEMENTS = "careerAchievements";
export const EXPLORING_AWARDS = "exploringAwards";
export const EXPLORING_REGULAR_AWARDS = "exploringRegularAwards";

export const SUB_UNITS_SUPPORT_BY_PROGRAM = {
  [SCOUTS_BSA]: true,
  [CUB_SCOUTING]: true,
  [SEA_SCOUTING]: false,
  [VARSITY_SCOUTING]: false,
  [VENTURING]: false,
  [EXPLORING_POST]: false,
  [EXPLORING_CLUB]: false,
  [EXPLORING_LAB]: false,
  [LONE_SCOUT]: false,
  [LONE_CUB]: false,
};

export default {
  PROGRAM_CODES,
  PROGRAM_CODES_BY_ID,
  PROGRAM_TYPE_CODES_BY_ID,
  PROGRAM_ID_BY_CODES,
  PROGRAM_NAMES,
  UNKNOWN_PROGRAM,
  SUB_UNITS_SUPPORT_BY_PROGRAM,
};
